import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MessageService, PrimeNGConfig } from 'primeng/api';
import { OperationService } from 'src/app/shared/service/operation/operation.service';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';
import { Constant } from 'src/app/shared/service/utils/contant';
import { DetailsPdcActionsComponent } from '../details-pdc-actions/details-pdc-actions.component';
import { DetailPdcProgrammeComponent } from '../detail-pdc-programme/detail-pdc-programme.component';
import { DetailsPdcActivitesComponent } from '../details-pdc-activites/details-pdc-activites.component';

@Component({
  selector: 'app-importation-pdc',
  standalone: false,
  templateUrl: './importation-pdc.component.html',
  styleUrl: './importation-pdc.component.scss'
})
export class ImportationPdcComponent {
  fileName: string = '';
  anneeDebut: any | null = null;
  dateAdoption: string | null = null;
  totalProgrammes: number = 0;
  totalActions: number = 0;
  totalActivites: number = 0;
  pdcReference: string = "";
  image: any;
  showcard: boolean = false;
  pdcExcelItems: any = [];
  isSubmitted: boolean = false;

  constructor(
    private http: HttpClient,
    private operationService: OperationService,
    private messageService: MessageService,
    private router: Router,
    private localStorage: LocalStorageService,
    private loader: NgxUiLoaderService,
    private modalService: NgbModal,
  ) { }

  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.fileName = file.name;
      this.image = file;
      this.isSubmitted = true;

    }
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    (event.currentTarget as HTMLElement).classList.add('drag-over');
  }

  onDragLeave(event: DragEvent) {
    (event.currentTarget as HTMLElement).classList.remove('drag-over');
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    (event.currentTarget as HTMLElement).classList.remove('drag-over');

    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      this.fileName = files[0].name;
      this.image = files[0];
      this.isSubmitted = true;
    }
  }

  uploadFile() {
    if (!this.fileName) {
      this.messageService.add({ severity: 'info', summary: Constant.suiviTitle, detail: "Veuillez remplir tous les champs avant d'envoyer" });
      return;
    }

    if (!this.anneeDebut) {
      this.messageService.add({ severity: 'info', summary: Constant.suiviTitle, detail: "Veuillez renseigner l'année" });
      return;
    }

    if (!this.dateAdoption) {
      this.messageService.add({ severity: 'info', summary: Constant.suiviTitle, detail: "Veuillez renseigner la date d'adoption" });
      return;
    }

    // Vérifier si dateAdoption est antérieure à anneeDebut
    // const adoptionYear = new Date(this.dateAdoption).getFullYear();
    // if (adoptionYear >= this.anneeDebut) {
    //   this.messageService.add({
    //     severity: 'info',
    //     summary: Constant.suiviTitle,
    //     detail: "La date d'adoption doit être antérieure à l'année de début"
    //   });
    //   return;
    // }

    const formData = new FormData();
    formData.append('file', this.image);
    formData.append('annee_debut', this.anneeDebut.toString());
    formData.append('date_adoption', this.dateAdoption);
    this.loader.start();

    this.localStorage.saveAnneImportation(this.anneeDebut)
    this.operationService.checkExcel(formData).subscribe(
      (response: any) => {
        //console.log("la réponse du webservice", response);

        this.showcard = true;
        this.pdcExcelItems = response.data;

        this.totalProgrammes = this.pdcExcelItems?.stats?.nbre_programmes;
        this.totalActions = this.pdcExcelItems?.stats?.nbre_actions;
        this.totalActivites = this.pdcExcelItems?.stats?.nbre_activites;
        this.pdcReference = this.pdcExcelItems?.pdc_reference;

        this.messageService.add({ severity: 'success', summary: Constant.suiviTitle, detail: response.message });
        this.loader.stop();

        this.anneeDebut = " "
        this.dateAdoption = " "
        this.fileName = " "
        this.isSubmitted = false;
      },
      (error: any) => {
        //console.log("une erreur est survenu", error);
        this.messageService.add({ severity: 'error', summary: Constant.suiviTitle, detail: error.error.message });
        this.loader.stop();

      }
    )
  }

  voirPlusAction(item: any) {
    this.localStorage.saveDetailPdcAction(this.pdcReference);
    this.modalService.open(DetailsPdcActionsComponent, {
      centered: true,
      backdrop: 'static',
      size: "xl"
    });
  }

  //voir le detail de financement des actions
  voirPlusPdcFinancementAction(item: any) {
    this.localStorage.saveDetailPdcFinancement(this.pdcReference);
    this.modalService.open(DetailPdcProgrammeComponent, {
      centered: true,
      backdrop: 'static',
      size: "xl"
    });
  }

  //voir le detail du financement des activites
  voirPlusPdcFinancementActivite(item: any) {
    this.localStorage.saveDetailPdcActivite(this.pdcReference);
    this.modalService.open(DetailsPdcActivitesComponent, {
      centered: true,
      backdrop: 'static',
      size: "xl"
    });
  }//end voirPlusPdcFinancementActivite

    @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  
    triggerFileInput() {
      if (this.fileInput) {
        this.fileInput.nativeElement.value = '';
        this.fileInput.nativeElement.click();
      }
    }
}
